module.exports = __webpack_public_path__ + "img/course-cover06.6108dfa4.png";